import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faRoad,
    faMapMarkerAlt,
    faBolt,
    faAlignJustify,
    faGavel,
    faShoppingCart,
    faQuestionCircle,
    faCreditCard,
    faBars,
    faCloudUploadAlt,
    faUser,
    faUsers,
    faPencilAlt,
    faEnvelope,
    faPhone,
    faChevronUp,
    faChevronDown,
    faDownload,
    faCopy,
    faUserPlus,
    faCheck,
    faTimes,
    faCloudDownloadAlt,
    faUpload,
    faFolder, faFolderOpen,
    faTrashAlt,
    faInfoCircle,
    faPlus,
    faKey,
    faSearch
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faRoad,
    faMapMarkerAlt,
    faBolt,
    faAlignJustify,
    faGavel,
    faShoppingCart,
    faQuestionCircle,
    faCreditCard,
    faBars,
    faCloudUploadAlt,
    faUser,
    faUsers,
    faPencilAlt,
    faEnvelope,
    faPhone,
    faChevronUp,
    faChevronDown,
    faDownload,
    faCopy,
    faUserPlus,
    faCheck,
    faTimes,
    faCloudDownloadAlt,
    faUpload,
    faFolder, faFolderOpen,
    faTrashAlt,
    faInfoCircle,
    faPlus,
    faKey,
    faSearch
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
